import React from 'react';
import PropTypes from 'prop-types';

import MPaper from 'components/MaterialUI/MPaper';
import MGrid from 'components/MaterialUI/MGrid';
import FormInputDisplay from 'components/FormElements/FormInputDisplay';
import instance from 'connection/instance';
import { IconExcel, IconPdf } from 'assets/icons';
import MTooltip from 'components/MaterialUI/MTooltip';
import { downloadFile, turnOffEvent } from 'utils/helpers';
import { pricingInfoToText } from 'utils/money';
import { Grid, IconButton } from '@mui/material';

const ICONS = {
  xlsx: <IconExcel />,
  pdf: <IconPdf />,
};

const PaymentInvoiceCard = ({ number, receipts, total }) => {
  const handleLoadFile =
    ({ file_url }) =>
    (e) => {
      turnOffEvent(e);
      instance
        .get(file_url, {
          responseType: 'blob',
        })
        .then((response) => downloadFile(response, `Счет ${number}`))
        .catch((error) => console.error(error));
    };

  return (
    <Grid item xs={12}>
      <MPaper>
        <Grid container spacing={1}>
          <MGrid size={12} spacing={2} alignItems="center" justifyContent="space-between">
            <MGrid spacing={3} alignItems="center" justifyContent="flex-start">
              <FormInputDisplay label={'Номер'} value={number} />
              <FormInputDisplay label={'Создан'} value={''} />
              <FormInputDisplay label={'Оплата до'} value={''} />
              <FormInputDisplay label={'К оплате'} value={pricingInfoToText(total?.amount)} />
            </MGrid>
            <MGrid spacing={3} alignItems="center" justifyContent="flex-start">
              {receipts?.map((document, index) => (
                <MTooltip arrow key={index} title={`Скачать ${document.type === 'pdf' ? 'PDF' : 'Excel'} счет`}>
                  <IconButton onClick={handleLoadFile(document)} size="small">
                    {ICONS[document.type]}
                  </IconButton>
                </MTooltip>
              ))}
            </MGrid>
          </MGrid>
        </Grid>
      </MPaper>
    </Grid>
  );
};

PaymentInvoiceCard.propTypes = {
  number: PropTypes.string,
  receipts: PropTypes.array,
  order_item: PropTypes.object,
  total: PropTypes.object,
};

export default PaymentInvoiceCard;
